import { deleteRecord } from '@/entities/shared/record/delete-record';

export async function deleteItem(id: string): Promise<void> {
  await deleteRecord('items', id);
}
